import React from "react";
import { Card as AntCard, type CardProps as AntCardProps } from "antd";

export interface CardProps extends Omit<AntCardProps, 'title'> {
  /** 标题 */
  title?: React.ReactNode;
  /** 内容区域 */
  children?: React.ReactNode;
  /** 是否显示边框 */
  bordered?: boolean;
  /** 是否可悬停 */
  hoverable?: boolean;
  /** 卡片大小 */
  size?: "default" | "small";
}

type DocgenInfo = {
  displayName: string;
  description: string;
  props: Record<string, {
    name: string;
    required: boolean;
    description: string;
    type: { name: string; raw: string };
    defaultValue?: { value: string };
  }>;
};

type ComponentWithDocgen = React.FC<CardProps> & { __docgenInfo?: DocgenInfo };

/** 卡片容器，用于分组内容 */
export const Card: React.FC<CardProps> = ({ 
  title, 
  children, 
  bordered = true,
  hoverable = false,
  size = "default",
  ...rest 
}) => (
  <AntCard
    {...rest}
    title={title}
    bordered={bordered}
    hoverable={hoverable}
    size={size}
  >
    {children}
  </AntCard>
);

// 手动添加 docgen 信息
(Card as ComponentWithDocgen).__docgenInfo = {
  displayName: "Card",
  description: "卡片容器，用于分组内容",
  props: {
    title: {
      name: "title",
      required: false,
      description: "标题",
      type: { name: "ReactNode", raw: "React.ReactNode" }
    },
    children: {
      name: "children",
      required: false,
      description: "内容区域",
      type: { name: "ReactNode", raw: "React.ReactNode" }
    },
    bordered: {
      name: "bordered",
      required: false,
      description: "是否显示边框",
      type: { name: "boolean", raw: "boolean" },
      defaultValue: { value: "true" }
    },
    hoverable: {
      name: "hoverable",
      required: false,
      description: "是否可悬停",
      type: { name: "boolean", raw: "boolean" },
      defaultValue: { value: "false" }
    },
    size: {
      name: "size",
      required: false,
      description: "卡片大小",
      type: { name: "CardSize", raw: '"default" | "small"' },
      defaultValue: { value: '"default"' }
    },
    loading: {
      name: "loading",
      required: false,
      description: "是否加载中",
      type: { name: "boolean", raw: "boolean" }
    },
    actions: {
      name: "actions",
      required: false,
      description: "卡片操作组",
      type: { name: "ReactNode[]", raw: "React.ReactNode[]" }
    }
  }
};
